// Country reference data (name, ISO codes, centroid) — generated from the
// mledoze/countries dataset (ODbL). Used by the Operations Area setting.
export const COUNTRIES = [
  { name: 'Afghanistan', iso2: 'AF', iso3: 'AFG', lat: 33.0, lng: 65.0 },
  { name: 'Albania', iso2: 'AL', iso3: 'ALB', lat: 41.0, lng: 20.0 },
  { name: 'Algeria', iso2: 'DZ', iso3: 'DZA', lat: 28.0, lng: 3.0 },
  { name: 'American Samoa', iso2: 'AS', iso3: 'ASM', lat: -14.3333, lng: -170.0 },
  { name: 'Andorra', iso2: 'AD', iso3: 'AND', lat: 42.5, lng: 1.5 },
  { name: 'Angola', iso2: 'AO', iso3: 'AGO', lat: -12.5, lng: 18.5 },
  { name: 'Anguilla', iso2: 'AI', iso3: 'AIA', lat: 18.25, lng: -63.1667 },
  { name: 'Antarctica', iso2: 'AQ', iso3: 'ATA', lat: -90.0, lng: 0.0 },
  { name: 'Antigua and Barbuda', iso2: 'AG', iso3: 'ATG', lat: 17.05, lng: -61.8 },
  { name: 'Argentina', iso2: 'AR', iso3: 'ARG', lat: -34.0, lng: -64.0 },
  { name: 'Armenia', iso2: 'AM', iso3: 'ARM', lat: 40.0, lng: 45.0 },
  { name: 'Aruba', iso2: 'AW', iso3: 'ABW', lat: 12.5, lng: -69.9667 },
  { name: 'Australia', iso2: 'AU', iso3: 'AUS', lat: -27.0, lng: 133.0 },
  { name: 'Austria', iso2: 'AT', iso3: 'AUT', lat: 47.3333, lng: 13.3333 },
  { name: 'Azerbaijan', iso2: 'AZ', iso3: 'AZE', lat: 40.5, lng: 47.5 },
  { name: 'Bahamas', iso2: 'BS', iso3: 'BHS', lat: 24.25, lng: -76.0 },
  { name: 'Bahrain', iso2: 'BH', iso3: 'BHR', lat: 26.0, lng: 50.55 },
  { name: 'Bangladesh', iso2: 'BD', iso3: 'BGD', lat: 24.0, lng: 90.0 },
  { name: 'Barbados', iso2: 'BB', iso3: 'BRB', lat: 13.1667, lng: -59.5333 },
  { name: 'Belarus', iso2: 'BY', iso3: 'BLR', lat: 53.0, lng: 28.0 },
  { name: 'Belgium', iso2: 'BE', iso3: 'BEL', lat: 50.8333, lng: 4.0 },
  { name: 'Belize', iso2: 'BZ', iso3: 'BLZ', lat: 17.25, lng: -88.75 },
  { name: 'Benin', iso2: 'BJ', iso3: 'BEN', lat: 9.5, lng: 2.25 },
  { name: 'Bermuda', iso2: 'BM', iso3: 'BMU', lat: 32.3333, lng: -64.75 },
  { name: 'Bhutan', iso2: 'BT', iso3: 'BTN', lat: 27.5, lng: 90.5 },
  { name: 'Bolivia', iso2: 'BO', iso3: 'BOL', lat: -17.0, lng: -65.0 },
  { name: 'Bosnia and Herzegovina', iso2: 'BA', iso3: 'BIH', lat: 44.0, lng: 18.0 },
  { name: 'Botswana', iso2: 'BW', iso3: 'BWA', lat: -22.0, lng: 24.0 },
  { name: 'Bouvet Island', iso2: 'BV', iso3: 'BVT', lat: -54.4333, lng: 3.4 },
  { name: 'Brazil', iso2: 'BR', iso3: 'BRA', lat: -10.0, lng: -55.0 },
  { name: 'British Indian Ocean Territory', iso2: 'IO', iso3: 'IOT', lat: -6.0, lng: 71.5 },
  { name: 'British Virgin Islands', iso2: 'VG', iso3: 'VGB', lat: 18.4314, lng: -64.6231 },
  { name: 'Brunei', iso2: 'BN', iso3: 'BRN', lat: 4.5, lng: 114.6667 },
  { name: 'Bulgaria', iso2: 'BG', iso3: 'BGR', lat: 43.0, lng: 25.0 },
  { name: 'Burkina Faso', iso2: 'BF', iso3: 'BFA', lat: 13.0, lng: -2.0 },
  { name: 'Burundi', iso2: 'BI', iso3: 'BDI', lat: -3.5, lng: 30.0 },
  { name: 'Cambodia', iso2: 'KH', iso3: 'KHM', lat: 13.0, lng: 105.0 },
  { name: 'Cameroon', iso2: 'CM', iso3: 'CMR', lat: 6.0, lng: 12.0 },
  { name: 'Canada', iso2: 'CA', iso3: 'CAN', lat: 60.0, lng: -95.0 },
  { name: 'Cape Verde', iso2: 'CV', iso3: 'CPV', lat: 16.0, lng: -24.0 },
  { name: 'Caribbean Netherlands', iso2: 'BQ', iso3: 'BES', lat: 12.18, lng: -68.25 },
  { name: 'Cayman Islands', iso2: 'KY', iso3: 'CYM', lat: 19.5, lng: -80.5 },
  { name: 'Central African Republic', iso2: 'CF', iso3: 'CAF', lat: 7.0, lng: 21.0 },
  { name: 'Chad', iso2: 'TD', iso3: 'TCD', lat: 15.0, lng: 19.0 },
  { name: 'Chile', iso2: 'CL', iso3: 'CHL', lat: -30.0, lng: -71.0 },
  { name: 'China', iso2: 'CN', iso3: 'CHN', lat: 35.0, lng: 105.0 },
  { name: 'Christmas Island', iso2: 'CX', iso3: 'CXR', lat: -10.5, lng: 105.6667 },
  { name: 'Cocos (Keeling) Islands', iso2: 'CC', iso3: 'CCK', lat: -12.5, lng: 96.8333 },
  { name: 'Colombia', iso2: 'CO', iso3: 'COL', lat: 4.0, lng: -72.0 },
  { name: 'Comoros', iso2: 'KM', iso3: 'COM', lat: -12.1667, lng: 44.25 },
  { name: 'Congo', iso2: 'CG', iso3: 'COG', lat: -1.0, lng: 15.0 },
  { name: 'Cook Islands', iso2: 'CK', iso3: 'COK', lat: -21.2333, lng: -159.7667 },
  { name: 'Costa Rica', iso2: 'CR', iso3: 'CRI', lat: 10.0, lng: -84.0 },
  { name: 'Croatia', iso2: 'HR', iso3: 'HRV', lat: 45.1667, lng: 15.5 },
  { name: 'Cuba', iso2: 'CU', iso3: 'CUB', lat: 21.5, lng: -80.0 },
  { name: 'Curaçao', iso2: 'CW', iso3: 'CUW', lat: 12.1167, lng: -68.9333 },
  { name: 'Cyprus', iso2: 'CY', iso3: 'CYP', lat: 35.0, lng: 33.0 },
  { name: 'Czechia', iso2: 'CZ', iso3: 'CZE', lat: 49.75, lng: 15.5 },
  { name: 'DR Congo', iso2: 'CD', iso3: 'COD', lat: 0.0, lng: 25.0 },
  { name: 'Denmark', iso2: 'DK', iso3: 'DNK', lat: 56.0, lng: 10.0 },
  { name: 'Djibouti', iso2: 'DJ', iso3: 'DJI', lat: 11.5, lng: 43.0 },
  { name: 'Dominica', iso2: 'DM', iso3: 'DMA', lat: 15.4167, lng: -61.3333 },
  { name: 'Dominican Republic', iso2: 'DO', iso3: 'DOM', lat: 19.0, lng: -70.6667 },
  { name: 'Ecuador', iso2: 'EC', iso3: 'ECU', lat: -2.0, lng: -77.5 },
  { name: 'Egypt', iso2: 'EG', iso3: 'EGY', lat: 27.0, lng: 30.0 },
  { name: 'El Salvador', iso2: 'SV', iso3: 'SLV', lat: 13.8333, lng: -88.9167 },
  { name: 'Equatorial Guinea', iso2: 'GQ', iso3: 'GNQ', lat: 2.0, lng: 10.0 },
  { name: 'Eritrea', iso2: 'ER', iso3: 'ERI', lat: 15.0, lng: 39.0 },
  { name: 'Estonia', iso2: 'EE', iso3: 'EST', lat: 59.0, lng: 26.0 },
  { name: 'Eswatini', iso2: 'SZ', iso3: 'SWZ', lat: -26.5, lng: 31.5 },
  { name: 'Ethiopia', iso2: 'ET', iso3: 'ETH', lat: 8.0, lng: 38.0 },
  { name: 'Falkland Islands', iso2: 'FK', iso3: 'FLK', lat: -51.75, lng: -59.0 },
  { name: 'Faroe Islands', iso2: 'FO', iso3: 'FRO', lat: 62.0, lng: -7.0 },
  { name: 'Fiji', iso2: 'FJ', iso3: 'FJI', lat: -18.0, lng: 175.0 },
  { name: 'Finland', iso2: 'FI', iso3: 'FIN', lat: 64.0, lng: 26.0 },
  { name: 'France', iso2: 'FR', iso3: 'FRA', lat: 46.0, lng: 2.0 },
  { name: 'French Guiana', iso2: 'GF', iso3: 'GUF', lat: 4.0, lng: -53.0 },
  { name: 'French Polynesia', iso2: 'PF', iso3: 'PYF', lat: -15.0, lng: -140.0 },
  { name: 'French Southern and Antarctic Lands', iso2: 'TF', iso3: 'ATF', lat: -49.25, lng: 69.167 },
  { name: 'Gabon', iso2: 'GA', iso3: 'GAB', lat: -1.0, lng: 11.75 },
  { name: 'Gambia', iso2: 'GM', iso3: 'GMB', lat: 13.4667, lng: -16.5667 },
  { name: 'Georgia', iso2: 'GE', iso3: 'GEO', lat: 42.0, lng: 43.5 },
  { name: 'Germany', iso2: 'DE', iso3: 'DEU', lat: 51.0, lng: 9.0 },
  { name: 'Ghana', iso2: 'GH', iso3: 'GHA', lat: 8.0, lng: -2.0 },
  { name: 'Gibraltar', iso2: 'GI', iso3: 'GIB', lat: 36.1333, lng: -5.35 },
  { name: 'Greece', iso2: 'GR', iso3: 'GRC', lat: 39.0, lng: 22.0 },
  { name: 'Greenland', iso2: 'GL', iso3: 'GRL', lat: 72.0, lng: -40.0 },
  { name: 'Grenada', iso2: 'GD', iso3: 'GRD', lat: 12.1167, lng: -61.6667 },
  { name: 'Guadeloupe', iso2: 'GP', iso3: 'GLP', lat: 16.25, lng: -61.5833 },
  { name: 'Guam', iso2: 'GU', iso3: 'GUM', lat: 13.4667, lng: 144.7833 },
  { name: 'Guatemala', iso2: 'GT', iso3: 'GTM', lat: 15.5, lng: -90.25 },
  { name: 'Guernsey', iso2: 'GG', iso3: 'GGY', lat: 49.4667, lng: -2.5833 },
  { name: 'Guinea', iso2: 'GN', iso3: 'GIN', lat: 11.0, lng: -10.0 },
  { name: 'Guinea-Bissau', iso2: 'GW', iso3: 'GNB', lat: 12.0, lng: -15.0 },
  { name: 'Guyana', iso2: 'GY', iso3: 'GUY', lat: 5.0, lng: -59.0 },
  { name: 'Haiti', iso2: 'HT', iso3: 'HTI', lat: 19.0, lng: -72.4167 },
  { name: 'Heard Island and McDonald Islands', iso2: 'HM', iso3: 'HMD', lat: -53.1, lng: 72.5167 },
  { name: 'Honduras', iso2: 'HN', iso3: 'HND', lat: 15.0, lng: -86.5 },
  { name: 'Hong Kong', iso2: 'HK', iso3: 'HKG', lat: 22.267, lng: 114.188 },
  { name: 'Hungary', iso2: 'HU', iso3: 'HUN', lat: 47.0, lng: 20.0 },
  { name: 'Iceland', iso2: 'IS', iso3: 'ISL', lat: 65.0, lng: -18.0 },
  { name: 'India', iso2: 'IN', iso3: 'IND', lat: 20.0, lng: 77.0 },
  { name: 'Indonesia', iso2: 'ID', iso3: 'IDN', lat: -5.0, lng: 120.0 },
  { name: 'Iran', iso2: 'IR', iso3: 'IRN', lat: 32.0, lng: 53.0 },
  { name: 'Iraq', iso2: 'IQ', iso3: 'IRQ', lat: 33.0, lng: 44.0 },
  { name: 'Ireland', iso2: 'IE', iso3: 'IRL', lat: 53.0, lng: -8.0 },
  { name: 'Isle of Man', iso2: 'IM', iso3: 'IMN', lat: 54.25, lng: -4.5 },
  { name: 'Israel', iso2: 'IL', iso3: 'ISR', lat: 31.47, lng: 35.13 },
  { name: 'Italy', iso2: 'IT', iso3: 'ITA', lat: 42.8333, lng: 12.8333 },
  { name: 'Ivory Coast', iso2: 'CI', iso3: 'CIV', lat: 8.0, lng: -5.0 },
  { name: 'Jamaica', iso2: 'JM', iso3: 'JAM', lat: 18.25, lng: -77.5 },
  { name: 'Japan', iso2: 'JP', iso3: 'JPN', lat: 36.0, lng: 138.0 },
  { name: 'Jersey', iso2: 'JE', iso3: 'JEY', lat: 49.25, lng: -2.1667 },
  { name: 'Jordan', iso2: 'JO', iso3: 'JOR', lat: 31.0, lng: 36.0 },
  { name: 'Kazakhstan', iso2: 'KZ', iso3: 'KAZ', lat: 48.0, lng: 68.0 },
  { name: 'Kenya', iso2: 'KE', iso3: 'KEN', lat: 1.0, lng: 38.0 },
  { name: 'Kiribati', iso2: 'KI', iso3: 'KIR', lat: 1.4167, lng: 173.0 },
  { name: 'Kosovo', iso2: 'XK', iso3: 'UNK', lat: 42.6667, lng: 21.1667 },
  { name: 'Kuwait', iso2: 'KW', iso3: 'KWT', lat: 29.5, lng: 45.75 },
  { name: 'Kyrgyzstan', iso2: 'KG', iso3: 'KGZ', lat: 41.0, lng: 75.0 },
  { name: 'Laos', iso2: 'LA', iso3: 'LAO', lat: 18.0, lng: 105.0 },
  { name: 'Latvia', iso2: 'LV', iso3: 'LVA', lat: 57.0, lng: 25.0 },
  { name: 'Lebanon', iso2: 'LB', iso3: 'LBN', lat: 33.8333, lng: 35.8333 },
  { name: 'Lesotho', iso2: 'LS', iso3: 'LSO', lat: -29.5, lng: 28.5 },
  { name: 'Liberia', iso2: 'LR', iso3: 'LBR', lat: 6.5, lng: -9.5 },
  { name: 'Libya', iso2: 'LY', iso3: 'LBY', lat: 25.0, lng: 17.0 },
  { name: 'Liechtenstein', iso2: 'LI', iso3: 'LIE', lat: 47.2667, lng: 9.5333 },
  { name: 'Lithuania', iso2: 'LT', iso3: 'LTU', lat: 56.0, lng: 24.0 },
  { name: 'Luxembourg', iso2: 'LU', iso3: 'LUX', lat: 49.75, lng: 6.1667 },
  { name: 'Macau', iso2: 'MO', iso3: 'MAC', lat: 22.1667, lng: 113.55 },
  { name: 'Madagascar', iso2: 'MG', iso3: 'MDG', lat: -20.0, lng: 47.0 },
  { name: 'Malawi', iso2: 'MW', iso3: 'MWI', lat: -13.5, lng: 34.0 },
  { name: 'Malaysia', iso2: 'MY', iso3: 'MYS', lat: 2.5, lng: 112.5 },
  { name: 'Maldives', iso2: 'MV', iso3: 'MDV', lat: 3.25, lng: 73.0 },
  { name: 'Mali', iso2: 'ML', iso3: 'MLI', lat: 17.0, lng: -4.0 },
  { name: 'Malta', iso2: 'MT', iso3: 'MLT', lat: 35.8333, lng: 14.5833 },
  { name: 'Marshall Islands', iso2: 'MH', iso3: 'MHL', lat: 9.0, lng: 168.0 },
  { name: 'Martinique', iso2: 'MQ', iso3: 'MTQ', lat: 14.6667, lng: -61.0 },
  { name: 'Mauritania', iso2: 'MR', iso3: 'MRT', lat: 20.0, lng: -12.0 },
  { name: 'Mauritius', iso2: 'MU', iso3: 'MUS', lat: -20.2833, lng: 57.55 },
  { name: 'Mayotte', iso2: 'YT', iso3: 'MYT', lat: -12.8333, lng: 45.1667 },
  { name: 'Mexico', iso2: 'MX', iso3: 'MEX', lat: 23.0, lng: -102.0 },
  { name: 'Micronesia', iso2: 'FM', iso3: 'FSM', lat: 6.9167, lng: 158.25 },
  { name: 'Moldova', iso2: 'MD', iso3: 'MDA', lat: 47.0, lng: 29.0 },
  { name: 'Monaco', iso2: 'MC', iso3: 'MCO', lat: 43.7333, lng: 7.4 },
  { name: 'Mongolia', iso2: 'MN', iso3: 'MNG', lat: 46.0, lng: 105.0 },
  { name: 'Montenegro', iso2: 'ME', iso3: 'MNE', lat: 42.5, lng: 19.3 },
  { name: 'Montserrat', iso2: 'MS', iso3: 'MSR', lat: 16.75, lng: -62.2 },
  { name: 'Morocco', iso2: 'MA', iso3: 'MAR', lat: 32.0, lng: -5.0 },
  { name: 'Mozambique', iso2: 'MZ', iso3: 'MOZ', lat: -18.25, lng: 35.0 },
  { name: 'Myanmar', iso2: 'MM', iso3: 'MMR', lat: 22.0, lng: 98.0 },
  { name: 'Namibia', iso2: 'NA', iso3: 'NAM', lat: -22.0, lng: 17.0 },
  { name: 'Nauru', iso2: 'NR', iso3: 'NRU', lat: -0.5333, lng: 166.9167 },
  { name: 'Nepal', iso2: 'NP', iso3: 'NPL', lat: 28.0, lng: 84.0 },
  { name: 'Netherlands', iso2: 'NL', iso3: 'NLD', lat: 52.5, lng: 5.75 },
  { name: 'New Caledonia', iso2: 'NC', iso3: 'NCL', lat: -21.5, lng: 165.5 },
  { name: 'New Zealand', iso2: 'NZ', iso3: 'NZL', lat: -41.0, lng: 174.0 },
  { name: 'Nicaragua', iso2: 'NI', iso3: 'NIC', lat: 13.0, lng: -85.0 },
  { name: 'Niger', iso2: 'NE', iso3: 'NER', lat: 16.0, lng: 8.0 },
  { name: 'Nigeria', iso2: 'NG', iso3: 'NGA', lat: 10.0, lng: 8.0 },
  { name: 'Niue', iso2: 'NU', iso3: 'NIU', lat: -19.0333, lng: -169.8667 },
  { name: 'Norfolk Island', iso2: 'NF', iso3: 'NFK', lat: -29.0333, lng: 167.95 },
  { name: 'North Korea', iso2: 'KP', iso3: 'PRK', lat: 40.0, lng: 127.0 },
  { name: 'North Macedonia', iso2: 'MK', iso3: 'MKD', lat: 41.8333, lng: 22.0 },
  { name: 'Northern Mariana Islands', iso2: 'MP', iso3: 'MNP', lat: 15.2, lng: 145.75 },
  { name: 'Norway', iso2: 'NO', iso3: 'NOR', lat: 62.0, lng: 10.0 },
  { name: 'Oman', iso2: 'OM', iso3: 'OMN', lat: 21.0, lng: 57.0 },
  { name: 'Pakistan', iso2: 'PK', iso3: 'PAK', lat: 30.0, lng: 70.0 },
  { name: 'Palau', iso2: 'PW', iso3: 'PLW', lat: 7.5, lng: 134.5 },
  { name: 'Palestine', iso2: 'PS', iso3: 'PSE', lat: 31.9, lng: 35.2 },
  { name: 'Panama', iso2: 'PA', iso3: 'PAN', lat: 9.0, lng: -80.0 },
  { name: 'Papua New Guinea', iso2: 'PG', iso3: 'PNG', lat: -6.0, lng: 147.0 },
  { name: 'Paraguay', iso2: 'PY', iso3: 'PRY', lat: -23.0, lng: -58.0 },
  { name: 'Peru', iso2: 'PE', iso3: 'PER', lat: -10.0, lng: -76.0 },
  { name: 'Philippines', iso2: 'PH', iso3: 'PHL', lat: 13.0, lng: 122.0 },
  { name: 'Pitcairn Islands', iso2: 'PN', iso3: 'PCN', lat: -25.0667, lng: -130.1 },
  { name: 'Poland', iso2: 'PL', iso3: 'POL', lat: 52.0, lng: 20.0 },
  { name: 'Portugal', iso2: 'PT', iso3: 'PRT', lat: 39.5, lng: -8.0 },
  { name: 'Puerto Rico', iso2: 'PR', iso3: 'PRI', lat: 18.25, lng: -66.5 },
  { name: 'Qatar', iso2: 'QA', iso3: 'QAT', lat: 25.5, lng: 51.25 },
  { name: 'Romania', iso2: 'RO', iso3: 'ROU', lat: 46.0, lng: 25.0 },
  { name: 'Russia', iso2: 'RU', iso3: 'RUS', lat: 60.0, lng: 100.0 },
  { name: 'Rwanda', iso2: 'RW', iso3: 'RWA', lat: -2.0, lng: 30.0 },
  { name: 'Réunion', iso2: 'RE', iso3: 'REU', lat: -21.15, lng: 55.5 },
  { name: 'Saint Barthélemy', iso2: 'BL', iso3: 'BLM', lat: 18.5, lng: -63.4167 },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', iso2: 'SH', iso3: 'SHN', lat: -15.95, lng: -5.72 },
  { name: 'Saint Kitts and Nevis', iso2: 'KN', iso3: 'KNA', lat: 17.3333, lng: -62.75 },
  { name: 'Saint Lucia', iso2: 'LC', iso3: 'LCA', lat: 13.8833, lng: -60.9667 },
  { name: 'Saint Martin', iso2: 'MF', iso3: 'MAF', lat: 18.0833, lng: -63.95 },
  { name: 'Saint Pierre and Miquelon', iso2: 'PM', iso3: 'SPM', lat: 46.8333, lng: -56.3333 },
  { name: 'Saint Vincent and the Grenadines', iso2: 'VC', iso3: 'VCT', lat: 13.25, lng: -61.2 },
  { name: 'Samoa', iso2: 'WS', iso3: 'WSM', lat: -13.5833, lng: -172.3333 },
  { name: 'San Marino', iso2: 'SM', iso3: 'SMR', lat: 43.7667, lng: 12.4167 },
  { name: 'Saudi Arabia', iso2: 'SA', iso3: 'SAU', lat: 25.0, lng: 45.0 },
  { name: 'Senegal', iso2: 'SN', iso3: 'SEN', lat: 14.0, lng: -14.0 },
  { name: 'Serbia', iso2: 'RS', iso3: 'SRB', lat: 44.0, lng: 21.0 },
  { name: 'Seychelles', iso2: 'SC', iso3: 'SYC', lat: -4.5833, lng: 55.6667 },
  { name: 'Sierra Leone', iso2: 'SL', iso3: 'SLE', lat: 8.5, lng: -11.5 },
  { name: 'Singapore', iso2: 'SG', iso3: 'SGP', lat: 1.3667, lng: 103.8 },
  { name: 'Sint Maarten', iso2: 'SX', iso3: 'SXM', lat: 18.0333, lng: -63.05 },
  { name: 'Slovakia', iso2: 'SK', iso3: 'SVK', lat: 48.6667, lng: 19.5 },
  { name: 'Slovenia', iso2: 'SI', iso3: 'SVN', lat: 46.1167, lng: 14.8167 },
  { name: 'Solomon Islands', iso2: 'SB', iso3: 'SLB', lat: -8.0, lng: 159.0 },
  { name: 'Somalia', iso2: 'SO', iso3: 'SOM', lat: 10.0, lng: 49.0 },
  { name: 'South Africa', iso2: 'ZA', iso3: 'ZAF', lat: -29.0, lng: 24.0 },
  { name: 'South Georgia', iso2: 'GS', iso3: 'SGS', lat: -54.5, lng: -37.0 },
  { name: 'South Korea', iso2: 'KR', iso3: 'KOR', lat: 37.0, lng: 127.5 },
  { name: 'South Sudan', iso2: 'SS', iso3: 'SSD', lat: 7.0, lng: 30.0 },
  { name: 'Spain', iso2: 'ES', iso3: 'ESP', lat: 40.0, lng: -4.0 },
  { name: 'Sri Lanka', iso2: 'LK', iso3: 'LKA', lat: 7.0, lng: 81.0 },
  { name: 'Sudan', iso2: 'SD', iso3: 'SDN', lat: 15.0, lng: 30.0 },
  { name: 'Suriname', iso2: 'SR', iso3: 'SUR', lat: 4.0, lng: -56.0 },
  { name: 'Svalbard and Jan Mayen', iso2: 'SJ', iso3: 'SJM', lat: 78.0, lng: 20.0 },
  { name: 'Sweden', iso2: 'SE', iso3: 'SWE', lat: 62.0, lng: 15.0 },
  { name: 'Switzerland', iso2: 'CH', iso3: 'CHE', lat: 47.0, lng: 8.0 },
  { name: 'Syria', iso2: 'SY', iso3: 'SYR', lat: 35.0, lng: 38.0 },
  { name: 'São Tomé and Príncipe', iso2: 'ST', iso3: 'STP', lat: 1.0, lng: 7.0 },
  { name: 'Taiwan', iso2: 'TW', iso3: 'TWN', lat: 23.5, lng: 121.0 },
  { name: 'Tajikistan', iso2: 'TJ', iso3: 'TJK', lat: 39.0, lng: 71.0 },
  { name: 'Tanzania', iso2: 'TZ', iso3: 'TZA', lat: -6.0, lng: 35.0 },
  { name: 'Thailand', iso2: 'TH', iso3: 'THA', lat: 15.0, lng: 100.0 },
  { name: 'Timor-Leste', iso2: 'TL', iso3: 'TLS', lat: -8.8333, lng: 125.9167 },
  { name: 'Togo', iso2: 'TG', iso3: 'TGO', lat: 8.0, lng: 1.1667 },
  { name: 'Tokelau', iso2: 'TK', iso3: 'TKL', lat: -9.0, lng: -172.0 },
  { name: 'Tonga', iso2: 'TO', iso3: 'TON', lat: -20.0, lng: -175.0 },
  { name: 'Trinidad and Tobago', iso2: 'TT', iso3: 'TTO', lat: 11.0, lng: -61.0 },
  { name: 'Tunisia', iso2: 'TN', iso3: 'TUN', lat: 34.0, lng: 9.0 },
  { name: 'Turkmenistan', iso2: 'TM', iso3: 'TKM', lat: 40.0, lng: 60.0 },
  { name: 'Turks and Caicos Islands', iso2: 'TC', iso3: 'TCA', lat: 21.75, lng: -71.5833 },
  { name: 'Tuvalu', iso2: 'TV', iso3: 'TUV', lat: -8.0, lng: 178.0 },
  { name: 'Türkiye', iso2: 'TR', iso3: 'TUR', lat: 39.0, lng: 35.0 },
  { name: 'Uganda', iso2: 'UG', iso3: 'UGA', lat: 1.0, lng: 32.0 },
  { name: 'Ukraine', iso2: 'UA', iso3: 'UKR', lat: 49.0, lng: 32.0 },
  { name: 'United Arab Emirates', iso2: 'AE', iso3: 'ARE', lat: 24.0, lng: 54.0 },
  { name: 'United Kingdom', iso2: 'GB', iso3: 'GBR', lat: 54.0, lng: -2.0 },
  { name: 'United States', iso2: 'US', iso3: 'USA', lat: 38.0, lng: -97.0 },
  { name: 'United States Minor Outlying Islands', iso2: 'UM', iso3: 'UMI', lat: 19.3, lng: 166.6333 },
  { name: 'United States Virgin Islands', iso2: 'VI', iso3: 'VIR', lat: 18.35, lng: -64.9333 },
  { name: 'Uruguay', iso2: 'UY', iso3: 'URY', lat: -33.0, lng: -56.0 },
  { name: 'Uzbekistan', iso2: 'UZ', iso3: 'UZB', lat: 41.0, lng: 64.0 },
  { name: 'Vanuatu', iso2: 'VU', iso3: 'VUT', lat: -16.0, lng: 167.0 },
  { name: 'Vatican City', iso2: 'VA', iso3: 'VAT', lat: 41.9, lng: 12.45 },
  { name: 'Venezuela', iso2: 'VE', iso3: 'VEN', lat: 8.0, lng: -66.0 },
  { name: 'Vietnam', iso2: 'VN', iso3: 'VNM', lat: 16.1667, lng: 107.8333 },
  { name: 'Wallis and Futuna', iso2: 'WF', iso3: 'WLF', lat: -13.3, lng: -176.2 },
  { name: 'Western Sahara', iso2: 'EH', iso3: 'ESH', lat: 24.5, lng: -13.0 },
  { name: 'Yemen', iso2: 'YE', iso3: 'YEM', lat: 15.0, lng: 48.0 },
  { name: 'Zambia', iso2: 'ZM', iso3: 'ZMB', lat: -15.0, lng: 30.0 },
  { name: 'Zimbabwe', iso2: 'ZW', iso3: 'ZWE', lat: -20.0, lng: 30.0 },
  { name: 'Åland Islands', iso2: 'AX', iso3: 'ALA', lat: 60.1167, lng: 19.9 },
];

export const countryByIso2 = (iso2) => COUNTRIES.find((c) => c.iso2 === iso2) || null;
